// Ciudad y estado de una direccion; si no los tiene, una raya y no ", ".
export const lugar = (dir) => [dir?.city, dir?.state].filter(Boolean).join(', ') || '—';
